module.exports = __webpack_public_path__ + "img/tg.12d2b96c.svg";